import http from '@/plugins/axios/axios';

export default class ClienteAppService {

    listar(requisicao) {
        return http.post('/api/usuario-api/listar', requisicao);
    }

    listarCnpjs(requisicao) {
        return http.post('/api/usuario-api/listar-cnpjs', requisicao);
    }

    criarUsuarioDesktop(requisicao) {
        return http.post('/api/usuario-api/criar-usuario-desktop', requisicao);
    }

    criarUsuarioMobile(requisicao) {
        return http.post('/api/usuario-api/criar-usuario-mobile', requisicao);
    }

    gerarSenhaCodigo(requisicao) {
        return http.post('/api/usuario-api/gerar-senha-codigo', requisicao);
    }

    excluir(requisicao) {
        return http.post('/api/usuario-api/excluir', requisicao);
    }
}